module.exports = __webpack_public_path__ + "static/ma-1-da5d5a61d3bfd799b53990c9eddbd0a5.png";